module.exports = __webpack_public_path__ + "static/media/thumb.d7ec745c.png";